// extracted by mini-css-extract-plugin
export default {"body":"feature-toggle_body__0ti+b","actions":"feature-toggle_actions__qtaOB"};